import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@clerk/react";

export function IndexRedirect() {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) return null;

  return (
    <Navigate
      to={{
        pathname: isSignedIn ? "/flavors/new" : "/sign-in",
        search: location.search,
      }}
      replace
    />
  );
}
